/**
 * Provider-neutral telemetry surface.
 *
 * Application code never imports a vendor SDK; it takes a {@link Telemetry} as
 * a parameter (on the API this is `context.telemetry`, in the browser it is
 * injected under `telemetryKey`) and calls these methods. The published
 * guarantee is that _no call site names a provider_. Swapping the backing
 * service touches the two adapters, the API's `instrument.ts` bootstrap, and
 * the dependency and deploy-env declarations — not a sweep of the tree.
 *
 * Logging deliberately is NOT part of this interface: `pino` on the API and
 * `console` in the browser already are the neutral logging surface, and the
 * provider adapter subscribes to them instead.
 */
/**
 * A {@link Telemetry} that records nothing. Used wherever no provider is
 * configured (local dev, tests, unconfigured deployments) so call sites never
 * have to null-check.
 */
export function noopTelemetry() {
    return {
        captureError: () => { },
        captureMessage: () => { },
        setUser: () => { },
        span: (_name, callback) => callback(),
        metrics: {
            count: () => { },
            gauge: () => { },
            distribution: () => { },
        },
    };
}
//# sourceMappingURL=index.js.map